import { SSwitch } from './Switch.styles';
import { TSwitchProps } from './Switch.types';

export const Switch = ({ ...props }: TSwitchProps) => {
  return <SSwitch {...props} />;
};
